import { fetchAPI } from './client';
import { MfaEnrollment, MfaStatus } from '../types';

export const MfaAPI = {
  status: async (): Promise<MfaStatus> => {
    return fetchAPI('/mfa');
  },

  enroll: async (): Promise<MfaEnrollment> => {
    return fetchAPI('/mfa/enroll', { method: 'POST' });
  },

  /** Confirms the first code, which is what promotes the factor to verified. */
  confirmEnrollment: async (
    factorId: string,
    code: string,
  ): Promise<{ message: string }> => {
    return fetchAPI('/mfa/enroll/verify', {
      method: 'POST',
      body: JSON.stringify({ factorId, code }),
    });
  },

  disable: async (): Promise<{ message: string }> => {
    return fetchAPI('/mfa/disable', { method: 'POST' });
  },

  /** Completes a login that stopped at the second factor. */
  verifyLogin: async (code: string): Promise<{ message: string }> => {
    return fetchAPI('/auth/mfa/verify', {
      method: 'POST',
      body: JSON.stringify({ code }),
    });
  },
};
